import { CreatorAction } from "@/types/types";
import NextMessagePreview from "../../dashboard_campaign/inbox/NextMessagePreview";
import EmailThreadFrame from "./EmailThreadFrame";

interface NextMessageActionProps {
  action: CreatorAction;
  emailThread: any[];
  threadLoading: boolean;
}

export default function NextMessageAction({
  action,
  emailThread,
  threadLoading,
}: NextMessageActionProps) {
  return (
    <div className="flex flex-col items-start justify-center gap-4 w-full animate-in fade-in-0 slide-in-from-top-2 duration-250">
      <EmailThreadFrame
        action={action}
        emailThread={emailThread}
        threadLoading={threadLoading}
      />

      {!threadLoading && emailThread.length > 0 && (
        <div className="rounded-2xl border-t-0 overflow-hidden w-full">
          <NextMessagePreview
            creator_id={action._id}
            nextMessage={action.message || ""}
          />
        </div>
      )}
    </div>
  );
}
